import { utils } from "xlsx";
import XLSXS from "xlsx-style";
import FileSaver from "file-saver";
import moment from "moment";

const CHARCODE_A_UC = 65
const uppercaseAlphabet = new Array(26)
  .fill(null)
  .map((v, i) => String.fromCharCode(CHARCODE_A_UC + i))

const sheetList = uppercaseAlphabet.map((i) => `${i}1`)

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}

const centerSheetDataFunc = (sheetData) => {
  let letterList = uppercaseAlphabet.slice(0, sheetData[0].length)
  let tableCount = sheetData.length
  let result = []

  const numFunc = (str, len) => {
    return new Array(len).fill(null).map((v, i) => `${str}${i + 1}`)
  }

  for (let i = 0; i < letterList.length; i++) {
    result.push(numFunc(letterList[i], tableCount))
  }

  return result.flat(Infinity)
}

/**
 * 携带样式
 */
export function exportExeclAndStyle(sheet1data, sheet2data, sheet3data) {
  const wb = utils.book_new();
  const ws = utils.aoa_to_sheet(sheet1data);
  const ws2 = utils.aoa_to_sheet(sheet2data);
  const ws3 = utils.aoa_to_sheet(sheet3data);
  utils.book_append_sheet(wb, ws, "访问量总览");
  utils.book_append_sheet(wb, ws2, "访问量详情");
  utils.book_append_sheet(wb, ws3, "调用次数统计");
  const list_1 = sheetList.slice(0, sheet1data[0].length)
  const list_2 = sheetList.slice(0, sheet2data[0].length)
  const list_3 = sheetList.slice(0, sheet3data[0].length)

  const centerSheet1Data = centerSheetDataFunc(sheet1data)
  const centerSheet2Data = centerSheetDataFunc(sheet2data)
  const centerSheet3Data = centerSheetDataFunc(sheet3data)

  ws['!cols'] = [{
    wpx: 200
  }]
  for (let i in ws) {
    // if (centerSheet1Data.includes(i)) {
    //   ws[i].s = {
    //     alignment: {
    //       horizontal: 'center',
    //       vertical: 'center',
    //     }
    //   };
    // }
    if (list_1.includes(i)) {
      ws[i].s = {
        // alignment: {
        //   horizontal: 'center',
        //   vertical: 'center',
        // },
        font: {
          bold: true,
        },
        fill: {
          fgColor: {
            rgb: '93a9d7'
          }
        }
      };
    }
  }

  for (let i in ws2) {
    // if (centerSheet2Data.includes(i)) {
    //   ws2[i].s = {
    //     alignment: {
    //       horizontal: 'center',
    //       vertical: 'center',
    //     }
    //   };
    // }
    if (list_2.includes(i)) {
      ws2[i].s = {
        // alignment: {
        //   horizontal: 'center',
        //   vertical: 'center',
        // },
        font: {
          bold: true,
        },
        fill: {
          fgColor: {
            rgb: '93a9d7'
          }
        }
      };
    }
  }

  for (let i in ws3) {
    // if (centerSheet3Data.includes(i)) {
    //   ws3[i].s = {
    //     alignment: {
    //       horizontal: 'center',
    //       vertical: 'center',
    //     }
    //   };
    // }
    if (list_3.includes(i)) {
      ws3[i].s = {
        // alignment: {
        //   horizontal: 'center',
        //   vertical: 'center',
        // },
        font: {
          bold: true,
        },
        fill: {
          fgColor: {
            rgb: '93a9d7'
          }
        }
      };
    }
  }

  let wbout = XLSXS.write(wb, {
    bookType: "xlsx",
    bookSST: false,
    type: "binary"
  });
  FileSaver.saveAs(
    new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }),
    `数据导出_${moment().format('YYYYMMDD')}.xlsx`
  );
}

/**
 * 无样式
 */
export function exportExecl(sheet1data, sheet2data, sheet3data) {
  const sheet1 = utils.json_to_sheet(sheet1data);
  const sheet2 = utils.json_to_sheet(sheet2data);
  const sheet3 = utils.json_to_sheet(sheet3data);
  const wb = utils.book_new();
  utils.book_append_sheet(wb, sheet1, "访问量总览");
  utils.book_append_sheet(wb, sheet2, "访问量详情");
  utils.book_append_sheet(wb, sheet3, "调用次数统计");
  writeFileXLSX(wb, `数据导出_${moment().format('YYYYMMDD')}.xlsx.xlsx`)
}